import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../Button/Button';
import { IconChevronDown } from '../Icon/index';
/**
 * A button variant to be used with [`DropdownPopper`](#/Dialog%20components?id=dropdownpopper).
 *
 * @since 7.28.0
 */

var DropdownButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "DropdownButton",
  componentId: "c11n-8-64-0__sc-i5s403-0"
})([""]);
DropdownButton.propTypes = {
  /**
   * The button content.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  iconPosition: PropTypes.string,

  /**
   * @ignore
   */
  iconSize: PropTypes.string
};
DropdownButton.defaultProps = {
  icon: /*#__PURE__*/React.createElement(IconChevronDown, null),
  iconPosition: 'end',
  iconSize: 'xs'
};
/** @component */

export default DropdownButton;
export var StyledDropdownButton = DropdownButton;